module.exports = __webpack_public_path__ + "static/media/24UHCHR13.4cce43eb.jpg";